import { createRef, useEffect, useState } from 'react';

import ChatHeader from '@/components/chatHeader';
import { Resizable } from 're-resizable';
import { channelState, containerState } from '../../constant';
import ChatBody from '../chatBody/index';
import ChatContact from '../ChatContact';
import ChatForm from '../chatForm';

const ChatContainers = (props) => {
  // 终端，聊天配置数据、显示组件状态、按钮状态、设置按钮状态函数
  const {
    device,
    chatConfig,
    showWidget,
    toggleIcon,
    setToggleIcon,
    onEndChat,
    agentDisabled,
    setAgentDisabled,
    trainGetMessageCount,
    clearMessageCount,
    playTipAudio,
    agentInput,
    setAgentInput,
  } = props;
  // 控制窗口缩放状态
  const [zoomWindow, setZoomWindow] = useState(false);
  // 表单数据
  const [formData, setFormData] = useState({});
  // 傀儡变量转换zoomWindow类型 true/false
  const zoomWindowStrState = zoomWindow.toString();

  // const state = setContainerState();
  // const state = false;
  const [newChat, setNewChat] = useState(false);
  // 容器状态
  const [container, setContainer] = useState(null);

  const [messageDataId, setMessageDataId] = useState('');
  // 是否历史记录内容
  const [isHistory, setIsHistory] = useState(false);

  // 是否聊天中
  const [isChatting, setChatting] = useState(false);

  const [isDisconnect, setDisconnect] = useState(true);
  // 渠道状态
  const [channel, setChannel] = useState(null);
  // 是否可以转人工状态
  // const [agentDisabled, setAgentDisabled] = useState(setAgentDisabledValue);
  const [mobileAgentDisabled, setMobileAgentDisabled] = useState(false);
  // // 控制是否全屏
  // const [fullScreen, setFullScreen] = useState(false);
  // // 控制是否显示客服图标
  // const [noIcon, setNoIcon] = useState(false);

  useEffect(() => {
    // 渠道配置数据
    let chatOpenChannelType = chatConfig.chatOpenChannelType;
    let inProgress = null;

    try {
      inProgress = JSON.parse(localStorage.getItem('inProgress'));
    } catch (error) {
      console.error('Failed to parse inProgress:', error);
      localStorage.removeItem('inProgress');
      return;
    }

    console.log('inprogress>>>', inProgress);
    // 1、判断是否是聊天中的
    // 如果聊天进行中，且有有效的messageDataId
    if (inProgress && inProgress.messageDataId && inProgress.messageDataId.trim() !== '') {
      // 是否存在此历史消息
      let isExistHistoryMessage = false;
      let isDisconnectTemp = false;

      try {
        // 获取historySession缓存值
        let channelList = JSON.parse(localStorage.getItem('historySession')) || [];
        console.log('channelList>>>', channelList);
        console.log('正在查找 messageDataId:', inProgress.messageDataId);

        if (channelList && Array.isArray(channelList) && channelList.length > 0) {
          const targetChannel = channelList.find(
            (cItem) => cItem.channelId === chatConfig.channelId && Array.isArray(cItem.list)
          );

          if (targetChannel) {
            console.log('找到目标渠道，消息列表长度:', targetChannel.list.length);
            const targetMessage = targetChannel.list.find((item1) => {
              console.log('比较 messageDataId:', item1.messageDataId, '与', inProgress.messageDataId);
              return item1.messageDataId === inProgress.messageDataId;
            });

            if (targetMessage) {
              console.log('找到历史消息:', targetMessage);
              isExistHistoryMessage = true;
              isDisconnectTemp = targetMessage.isDisconnect || false;
            } else {
              console.log('未找到匹配的历史消息');
            }
          } else {
            console.log('未找到目标渠道');
          }
        } else {
          console.log('channelList 为空或无效');
        }
      } catch (error) {
        console.error('Failed to parse historySession:', error);
        isExistHistoryMessage = false;
      }

      if (isExistHistoryMessage) {
        setMessageDataId(inProgress.messageDataId);
        setChatting(true);

        // 设置窗口开关状态
        if (inProgress.toggleIcon) {
          setToggleIcon(true);
        }
        //判断是否已经结束会话
        if (isDisconnectTemp) {
          console.log('会话已经结束，需要开启新回话');
          if (chatConfig.singleChat) {
            // singleChat模式下，不清空messageDataId，保持会话信息用于重连
            console.log('singleChat模式下保持会话信息用于重连');
            if (chatConfig.chatOpenChannelType === '3') {
              setChannel(channelState.IM_CHAT);
            } else {
              setChannel(channelState.KNOWLEDGE);
            }
            setNewChat(true);
            setDisconnect(false); // 设置为可以重连状态
          } else {
            setIsHistory(true);
          }
        }
        // 设置容器状态
        if (inProgress.container === 'video') {
          setContainer(containerState.VIDEO);
        } else {
          setContainer(containerState.CHAT_WIDGET);
        }
        // debugger;
        // 如果开启了人工功能。
        if (chatOpenChannelType === '1' || chatOpenChannelType === '3') {
          // 如果im session 不为空
          if (inProgress.imChatSessionId) {
            setChannel(channelState.IM_CHAT);
          } else {
            if (chatOpenChannelType === '3') {
              setChannel(channelState.IM_CHAT);
            } else {
              setChannel(channelState.KNOWLEDGE);
            }
          }
        } else {
          localStorage.removeItem('inProgress');
          setChannel(channelState.KNOWLEDGE);
        }
      } else {
        localStorage.removeItem('inProgress');
        setChannel(channelState.KNOWLEDGE);
        if (chatConfig.singleChat) {
          console.log('开启新对话1');
          setNewChat(true);
        }
      }
    } else {
      console.log('不在聊天中');
      // 如果开启了机器人和人工，设置聊天渠道为“机器人”
      if (chatOpenChannelType === '1' || chatOpenChannelType === '2') {
        setChannel(channelState.KNOWLEDGE);
      }
      // 如果只开启了人工，设置聊天渠道为“人工”
      if (chatOpenChannelType === '3') {
        setChannel(channelState.IM_CHAT);
      }
      //增加开启新回话
      if (chatConfig.singleChat) {
        console.log('开启新对话2');
        if (chatConfig.chatOpenChannelType === '3') {
          setChannel(channelState.IM_CHAT);
        } else {
          setChannel(channelState.KNOWLEDGE);
        }
        localStorage.removeItem('inProgress');

        setNewChat(true);
      }
    }
  }, [isChatting]);

  useEffect(() => {
    // 判断是否是只开启在线通话、在线视频
    if (chatConfig.isVideoContainer) {
      setContainer(containerState.VIDEO);
    } else {
      // 获取inProgress缓存值，判断是否存在进行中的回话
      let inProgress = JSON.parse(localStorage.getItem('inProgress'));
      if (toggleIcon && !inProgress) {
        // 判断本地是否有缓存的用户信息
        const localForm = JSON.parse(window.localStorage.getItem('goclouds-chat-form'));
        if (localForm) {
          let phoneNumber = localForm.phoneNumber;
          let userEmail = localForm.userEmail;
          let username = localForm.username;
          // 如果缓存中存在联系信息，不展示填写信息页
          if ((username && userEmail) || (username && phoneNumber)) {
            setFormData({
              chat_user_name: username,
              chat_email: userEmail,
              chat_phone_number: phoneNumber,
            });
          }
          // 判断是否是只开启在线通话、在线视频
          if (chatConfig.isVideoContainer) {
            setContainer(containerState.VIDEO);
          } else {
            setContainer(containerState.CONTACT);
          }
        } else {
          if (chatConfig.preChatForm.visible && !chatConfig.singleChat) {
            setContainer(containerState.FORM); // 切换至表单
          } else if (chatConfig.preChatForm.visible && chatConfig.needInfoCollection) {
            setContainer(containerState.FORM);
          } else {
            if (chatConfig.isVideoContainer) {
              setContainer(containerState.VIDEO);
            } else {
              setContainer(containerState.CONTACT);
            }
          }
        }
      }
    }
  }, [toggleIcon]);

  /*
    function setContainerState() {
      let containerStateValue = containerState.CONTACT;

      // 判断是否是只开启在线通话、在线视频
      if (chatConfig.isVideoContainer) {
        containerStateValue = containerState.VIDEO;
      }

      return containerStateValue;
    }

    function setChannelState() {
      // 渠道配置数据
      let chatOpenChannelType = chatConfig.chatOpenChannelType;

      // 获取inProgress缓存值，判断是否存在进行中的回话
      let inProgress = JSON.parse(localStorage.getItem('inProgress'));

      // 如果聊天进行中
      if (inProgress) {
        // 是否存在此历史消息
        let isExistHistoryMessage = false;
        let isDisconnectTemp = false;
        // 获取historySession缓存值
        let channelList = JSON.parse(localStorage.getItem('historySession')) || [];
        if (channelList && channelList.length !== 0) {
          channelList.forEach((cItem) => {
            if (cItem.channelId === chatConfig.channelId) {
              cItem.list.forEach((item1) => {
                // 判断是否存在消息数据
                if (item1.messageDataId === inProgress.messageDataId) {
                  isExistHistoryMessage = true;
                  isDisconnectTemp = item1.isDisconnect;
                }
              });
            }
          });
        }

        if (isExistHistoryMessage) {
          setMessageDataId(inProgress.messageDataId);
          setChatting(true);

          // 设置窗口开关状态
          if (inProgress.toggleIcon) {
            setToggleIcon(true);
          }
          if (isDisconnectTemp) {
            setIsHistory(true);
          }
          // 设置容器状态
          if (inProgress.container === 'video') {
            setContainer(containerState.VIDEO);
          } else {
            setContainer(containerState.CHAT_WIDGET);
          }

          // 如果开启了人工功能。
          if (chatOpenChannelType === '1' || chatOpenChannelType === '3') {
            // 如果im session 不为空
            if (inProgress.imChatSessionId) {
              return channelState.IM_CHAT;
            }
            // 如果connect session 不为空
            else if (inProgress.connectChatSession) {
              return channelState.CONNECT;
            } else {
              return channelState.KNOWLEDGE;
            }
          } else {
            localStorage.removeItem('inProgress');
            return channelState.KNOWLEDGE;
          }
        } else {
          localStorage.removeItem('inProgress');
          return channelState.KNOWLEDGE;
        }
      }

      // 如果开启了机器人和人工，设置聊天渠道为“机器人”
      if (chatOpenChannelType === '1' || chatOpenChannelType === '2') {
        return channelState.KNOWLEDGE;
      }
      // 如果只开启了人工，设置聊天渠道为“人工”
      if (chatOpenChannelType === '3') {
        return channelState.CONNECT;
      }
    }
    */
  function setAgentDisabledValue() {
    return chatConfig.chatOpenChannelType === '1' || chatConfig.chatOpenChannelType === '3';
  }
  function endChat() {
    bodyChildRef.current.endChat();
  }
  const singleReload = () => {
    localStorage.removeItem('inProgress');
    if (chatConfig.chatOpenChannelType === '3') {
      setChannel(channelState.IM_CHAT);
    } else {
      setChannel(channelState.KNOWLEDGE);
    }
    console.log('开启新对话2');
    setNewChat(true);
    window.location.reload();
  };
  const setContainerStyle = () => {
    let style = {};
    if (device === 'pc') {
      style = {
        width: chatConfig.fullScreen ? '100%' : '45vh',
        height: chatConfig.fullScreen ? '100vh' : '78vh',
        position: 'fixed',
        zIndex: '1000',
        bottom: chatConfig.fullScreen ? '0px' : '75px',
        right: chatConfig.fullScreen ? '0px' : '80px',
        transition: 'all 0.4s cubic-bezier(0.62, 0.28, 0.23, 0.99)',
        transformOrigin: 'bottom right',
        transform: showWidget ? 'scale(1)' : 'scale(0)',
        opacity: showWidget ? '1' : '0',
      };
    } else if (chatConfig.useNewMobileChat) {
      style = {
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
        height: 'calc(100% - 170px)',
        width: '100%',
        position: 'fixed',
        top: 180,
        left: 0,
        overflow: 'hidden',
        transition: 'all 0.4s cubic-bezier(0.62, 0.28, 0.23, 0.99)',
        transformOrigin: 'bottom',
        transform: showWidget ? 'scale(1)' : 'scale(0)',
        opacity: showWidget ? '1' : '0',
      };
    } else {
      style = {
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        overflow: 'hidden',
      };
    }
    return style;
  };
  const setResizableStyle = () => {
    let style = {};
    if (device === 'pc') {
      style = {
        background: 'linear-gradient(255, rgba(255, 255, 255, 0.8) 255)',
        boxShadow: 'rgb(221, 221, 221) 0 2px 3px',
        position: 'absolute',
        bottom: '0',
        right: '0',
        borderRadius: '10px 10px 45px 10px',
        overflow: 'hidden',
        zIndex: '1000',
      };
    } else {
      style = {};
    }
    return style;
  };
  const bodyChildRef = createRef();
  const chatContactRef = createRef();

  return (
    <div style={setContainerStyle()}>
      <Resizable
        style={setResizableStyle()}
        maxWidth={'200%'}
        maxHeight={'100%'}
        minWidth={device === 'pc' && chatConfig.fullScreen == false ? chatConfig.containerW || '80%' : '100%'}
        minHeight={device === 'pc' && chatConfig.fullScreen == false ? chatConfig.containerH || '50%' : '100%'}
        defaultSize={{
          width: device === 'pc' && chatConfig.fullScreen == false ? chatConfig.containerW || '100%' : '100%',
          height: device === 'pc' && chatConfig.fullScreen == false ? chatConfig.containerH || '90%' : '100%',
        }}
      >
        {chatConfig.noHeader && device === 'mobile' ? (
          ''
        ) : (
          <ChatHeader
            agentInput={agentInput}
            setAgentInput={setAgentInput}
            endChat={endChat}
            device={device}
            chatConfig={chatConfig}
            toggleIcon={toggleIcon}
            setToggleIcon={setToggleIcon}
            zoomWindow={zoomWindow}
            setZoomWindow={setZoomWindow}
            container={container}
            setContainer={setContainer}
            channel={channel}
            setChannel={setChannel}
            isHistory={isHistory}
            agentDisabled={agentDisabled}
            setAgentDisabled={setAgentDisabled}
            mobileAgentDisabled={mobileAgentDisabled}
            setMobileAgentDisabled={setMobileAgentDisabled}
            trainGetMessageCount={trainGetMessageCount}
          />
        )}

        {container === containerState.FORM ? (
          <ChatForm
            chatConfig={chatConfig}
            setFormData={setFormData}
            setContainer={setContainer}
            device={device}
            formData={formData}
          />
        ) : (
          ''
        )}
        {container === containerState.CHAT_WIDGET || container === containerState.VIDEO ? (
          <ChatBody
            agentInput={agentInput}
            setAgentInput={setAgentInput}
            ref={bodyChildRef}
            chatConfig={chatConfig}
            formData={formData}
            setFormData={setFormData}
            zoomWindow={zoomWindow}
            toggleIcon={toggleIcon}
            setToggleIcon={setToggleIcon}
            container={container}
            setContainer={setContainer}
            channel={channel}
            setChannel={setChannel}
            device={device}
            messageDataId={messageDataId}
            setMessageDataId={setMessageDataId}
            isHistory={isHistory}
            setIsHistory={setIsHistory}
            isChatting={isChatting}
            setChatting={setChatting}
            isDisconnect={isDisconnect}
            setDisconnect={setDisconnect}
            agentDisabled={agentDisabled}
            setAgentDisabled={setAgentDisabled}
            mobileAgentDisabled={mobileAgentDisabled}
            setMobileAgentDisabled={setMobileAgentDisabled}
            onEndChat={onEndChat}
            playTipAudio={playTipAudio}
            singleReload={singleReload}
          />
        ) : (
          ''
        )}
        {container === containerState.CONTACT || container === containerState.CONTACT_DETAIL ? (
          <ChatContact
            newChat={newChat}
            ref={chatContactRef}
            chatConfig={chatConfig}
            container={container}
            setContainer={setContainer}
            device={device}
            setFormData={setFormData}
            setMessageDataId={setMessageDataId}
            setIsHistory={setIsHistory}
            setDisconnect={setDisconnect}
            setChatting={setChatting}
            channel={channel}
            setChannel={setChannel}
            setAgentDisabled={setAgentDisabled}
            trainGetMessageCount={trainGetMessageCount}
            clearMessageCount={clearMessageCount}
          />
        ) : (
          ''
        )}
      </Resizable>
    </div>
  );
};

export default ChatContainers;
